import { useState, useEffect } from 'react';
import _ from 'lodash';

/**
 * Render At
 * @category Functional Component
 * @extends Component
 * @summary Renders a component at a specific screen width.
 * @prop {string} operator - The operator, accepts "lt" & "gt".
 * @prop {string} trigger - At what point do we render.
 * @return {Node} React node containing rendered component.
 */

const RenderAt = (props) => {
  const { operator, trigger } = props;
  const [isAtBreak, setIsAtBreak] = useState(0);

  useEffect(() => {
    const checkBreak = () => {
      let isSet = false;

      if(operator === 'lt') {
        if(window.innerWidth < trigger) {
          isSet = true;
        }
      }

      if(operator === 'gt') {
        if(window.innerWidth > trigger) {
          isSet = true;
        }
      }

      setIsAtBreak(isSet);
    }

    const debounceResize = _.debounce(() => {
      checkBreak();
    }, 100)

    window.addEventListener('resize', debounceResize);
    checkBreak(); // First Load

    return () => {
      window.removeEventListener('resize', debounceResize);
    }
  });

  if(isAtBreak) {
    return (
      <>
        { props.children }
      </>
    );
  }

  return false;
}

export default RenderAt;
